import styled from '@emotion/styled';
import media from 'css-in-js-media';

export const StyledDetails = styled.div`
  /* display: flex;
  justify-content: flex-start;
  align-items: center; */
  color: rgba(51, 51, 51, 0.75);
  font-size: 12px;
  margin: 0;
  line-height: 0.95rem;

  &.featured {
    margin: 16px 0 24px 0;
  }

  ${media('<desktop')} {
    display: none;

    &.featured {
      display: flex;
      flex-direction: column;
    }
  }

  a {
    font-family: 'WorkSans-Regular', 'Helvetica', 'sans-serif';
    margin-right: 2px;
    margin-left: 3px;
    color: hsl(215, 100%, 50%);
  }

  img {
    border-radius: 100px;
    margin-right: 5px;
    margin-top: -1px;
    object-fit: cover;
    width: 18px;
    height: 18px;
    float: left;
  }
`;
